<script lang="ts" setup>
import { inject, Ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { Dokument } from '/@src/client-portal'
import * as apisPortal from '/@src/client-portal/api'
import { useSteps } from '/@src/composable/useSteps'
import { NazvyKrokov } from '/@src/utils/zoppm/types'
import FileDownload from 'js-file-download'
import { useNotyf } from '/@src/composable/useNotyf'
import { ZoPPMPriloha } from '/@src/client-is'

export interface Step13Rozpocet {
  prilohy: ZoPPMPriloha[]
}

const props = defineProps<Step13Rozpocet>()

const { t } = useI18n()
const steps = useSteps()
const api = new apisPortal.ZoppmDraftApi()
const kodIrz = inject<Ref<string>>('kodIrz')
const notif = useNotyf()

async function getDokument(dokument: Dokument) {
  const verziaUlozisko = dokument?.dokumentRef?.verziaUlozisko
  const identifikatorUlozisko = dokument?.dokumentRef?.identifikatorUlozisko

  if (kodIrz?.value && identifikatorUlozisko && verziaUlozisko) {
    try {
      await api
        .fetchContentOfDokumentForZoppmDraftZoppmDraft(
          kodIrz.value,
          identifikatorUlozisko,
          verziaUlozisko,
          undefined,
          undefined,
          { responseType: 'blob' }
        )
        .then((response) => {
          FileDownload(response.data, response.headers.filename)
        })
    } catch {
      notif.error('Nastala chyba')
    }
  }
}
</script>

<template>
  <IDSKHeading as="h3" variant="m" class="mt-7">
    {{ t('zoppm.step13.rozpocet') }}
  </IDSKHeading>

  <template v-for="priloha in props.prilohy" :key="priloha">
    <template v-if="Object.values(priloha?.dokumenty)?.length > 0">
      <IDSKLink
        v-for="dokument in Object.values(priloha?.dokumenty).flatMap((value) => value)"
        :key="dokument"
        href="#"
        no-visited-state
        class="mb-5 d-block line-break-anywhere"
        @click.prevent="() => getDokument(dokument)"
      >
        {{ `${dokument?.nazov}.${dokument?.format}` }}
      </IDSKLink>
    </template>
  </template>

  <IDSKButton
    class="mb-0"
    variant="secondary"
    type="button"
    :data-test-id="`zoppm-rozpocet-edit-priloh`"
    @click="
      () =>
        steps.setStep(NazvyKrokov['rozpocet'], {
          ref: NazvyKrokov['zhrnutie'],
        })
    "
  >
    {{ t('zoppm.step13.editAttachments') }}
  </IDSKButton>
</template>
